import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const success = (message) => {
  MySwal.fire({
    toast: true,
    position: "top",
    text: message,
    showCancelButton: false,
    showConfirmButton: false,
    timer: 3000,
    background: "#5D7D73",
    color: "#fff",
    width: 600,
  });
};

const responseValidate = (title, message) => {
  const defaultMessage = "Oops, something went wrong. Tanam Emas team has been notified and will look into this.";
  MySwal.fire({
    icon: "error",
    title: title,
    html: message || defaultMessage,
  });
};

const loadingAlert = () => {
  Swal.fire({
    title: "Loading",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const PopupUtility = {
  success,
  responseValidate,
  loadingAlert,
};

export default PopupUtility;
